import React from 'react'
import Container from 'react-bootstrap/Container';

function Gallery({urls, }) {
    
    const slide_width = 300
    const items = urls.map((videoUrl) =>
        
    
        <iframe width={""+slide_width} height={"" + slide_width*315/560}
            src={videoUrl} 
            data-src={videoUrl}
            title="YouTube video player" frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen="True">
        </iframe>

    );
    return (
        <div>
            <Container max-width="900px"> 
                <div class="row justify-content-center">
                    {items}
                </div>
            </Container>
                            
        </div>
    );
}


export default Gallery


